import { GlossaryItem } from '@features/glossary/domain/glossary';
import { SHARED_GLOSSARY } from '@features/glossary/domain/shared-glossary';

export const GLOSSARY: Record<string, GlossaryItem> = {
  adSpend: SHARED_GLOSSARY.adSpend,
  attributionMetrics: {
    label: 'Attribution Metrics',
    definition:
      'Sales measurement based on receipt scan data related to exposed users matched to synthetic control group that can thereby be attributed to the effects of advertising.  Attribution metrics include Incremental Lift and Incremental Sales.',
  },
  averagePricePerTransaction: {
    label: 'Average Price per Transaction',
    definition:
      'Among those who purchase Brand, average amount spent on Brand per transaction.',
  },
  averagePricePerTransactionLift: {
    label: 'Average Price per Transaction Lift',
    definition:
      'Measures the percentage increase in lift in the Average Price per Transaction by the exposed compared to the control.',
  },
  averagePurchaseFrequency: {
    label: 'Average Purchase Frequency',
    definition:
      'Average frequency of purchases of the brand during the campaign.',
  },
  averagePurchaseFrequencyLift: {
    label: 'Average Purchase Frequency Lift',
    definition:
      'Measures the percentage increase in lift in the Average Purchase Frequency by the exposed compared to the control.',
  },
  averageTotalBasketAmount: {
    label: 'Average Total Basket Amount',
    definition:
      'Average total size of the purchase when the brand being measured is present in the basket.',
  },
  campaignEndDate: SHARED_GLOSSARY.campaignEndDate,
  campaignStartDate: SHARED_GLOSSARY.campaignStartDate,
  confidenceLevel: SHARED_GLOSSARY.confidenceLevel,
  dimension: SHARED_GLOSSARY.dimension,
  dimensionValue: SHARED_GLOSSARY.dimensionValue,
  dollarsPerUser: {
    label: 'Dollars per User',
    definition: 'Sales per exposed user.',
  },
  flightDates: SHARED_GLOSSARY.flightDates,
  impression: SHARED_GLOSSARY.impression,
  incrementalDollarsPerUser: {
    label: 'Incremental Dollars per User',
    definition: 'Incremental sales per exposed user.',
  },
  incrementalSales: SHARED_GLOSSARY.incrementalSales,
  incrementalSalesLift: SHARED_GLOSSARY.incrementalSalesLift,
  measurementEndDate: SHARED_GLOSSARY.measurementEndDate,
  measurementPeriod: {
    label: 'Measurement Period',
    definition:
      'The range of days for which impression and sales data are included in a campaign measurement report, from the measurement start date to the end of the measurement end date.',
  },
  measurementStartDate: SHARED_GLOSSARY.measurementStartDate,
  multiTouchAttribution: SHARED_GLOSSARY.multiTouchAttribution,
  penetration: SHARED_GLOSSARY.penetration,
  penetrationLift: {
    label: 'Penetration Lift',
    definition:
      'Measures the percentage increase in lift in the Penetration by the exposed compared to the control.',
  },
  postCampaignMeasurementPeriod: {
    label: 'Post-Campaign Measurement Period',
    definition:
      'The period after the Campaign End Date used to observe sales data. In a standard campaign, this period is 14 days.',
  },
  purchaseFrequency: {
    label: 'Purchase Frequency',
    definition:
      'Among those who purchase, how many occasions (trips) during campaign window Brand was purchased.',
  },
  returnOnAdSpend: SHARED_GLOSSARY.returnOnAdSpend,
  salesRate: SHARED_GLOSSARY.salesRate,
  totalBasketSize: {
    label: 'Total Basket Size',
    definition: 'Average total order size for those who purchased Brand.',
  },
  totalProjectedSales: {
    label: 'Total Projected Sales',
    definition:
      'The total post-exposure sales by a set of unique users during a specified time period.',
  },
  transactionRate: SHARED_GLOSSARY.transactionRate,
  uniqueRetailerBanners: {
    label: 'Unique Retailer Banners',
    definition: 'The number of unique retailers used in a measurement report.',
  },
  uniqueUser: SHARED_GLOSSARY.uniqueUser,
  usersMatchedForAttribution: SHARED_GLOSSARY.usersMatchedForAttribution,
};
